<template>
  <CollapsibleCard
    :value="true"
    :padding="false"
    :collapsibleIcon="icon"
    :collapsibleTitle="title"
    :total="total"
  >
    <template v-slot>
      <div
        class="caseCardContainer"
        v-for="(complaint, index) in data"
        :key="index"
      >
        <CaseCard
          :tile="true"
          :elevation="0"
          :title="complaint.lineName"
          :deadline="complaint.deadLine"
          :underLeft="complaint.projectName"
          :underRight="complaint.contactPersonName"
          :status="complaint.status"
          :color="getColor(complaint)"
          @click="goTo(complaint)"
        >
          <template v-slot:chips>
            <div v-for="(chip, index) in getChips(complaint)" :key="index">
              <v-chip class="mr-2" :color="chip.color" small>
                {{ chip.title }}
              </v-chip>
            </div>
          </template>
          <template v-slot:underLeft>
            {{ complaint.projectName }}
            {{
              complaint.projectName && complaint.projSectionApartNum ? "-" : ""
            }}
            {{ complaint.projSectionApartNum }}
          </template>
        </CaseCard>
      </div>
      <ShowCollapsibleCardBtns
        :projectId="projectId"
        :houseName="houseName"
        filterNameProject="projectOid"
        filterNameHouse="projSectionApartNum"
        :routeName="isEnquiry ? 'Requests' : 'Complaints'"
      />
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import complaintApi from "@/api/complaintApi";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import ShowCollapsibleCardBtns from "@/components/shared/cards/ShowCollapsibleCardBtns.vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";

export default Vue.extend({
  name: "DashboardComplaints",
  props: {
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    projectId: {
      default: "",
    },
    houseId: {
      default: null,
    },
    houseName: {
      default: null,
    },
  },
  data: () => ({
    loading: true,
    data: [],
    total: 0,
    complaints: [
      {
        title: "Bergbakken",
        status: "Ferdigstilt",
        color: "success",
        sameie: true,
      },
      {
        title: "Evangtunet",
        status: "Under avklaring",
        color: "warning",
      },
      {
        title: "Ekeberg",
        status: "Ubehandlet",
        color: "error",
      },
    ],
  }),
  async mounted() {
    await this.fetchData();
    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  methods: {
    async fetchData() {
      var headers = [
        {
          text: "isEnquiry",
          value: "isEnquiry",
          type: "boolean",
          show: false,
          filterValues: [this.isEnquiry.toString()],
          filterClause: 0,
          filterName: "isEnquiry",
          removeFilter: true,
        },
        {
          text: "Status",
          value: "regStatus",
          type: "int",
          show: true,
          filterValues: [0, 1, 4, 6, 7],
          filterClause: 0,
          filterName: "lineStatus",
          sortable: false,
        },
        {
          text: "Prosjekt",
          value: "projectOid",
          type: "string",
          show: true,
          filterValues: this.projectId ? [this.projectId] : "",
          filterClause: 0,
          filterName: "projectOid",
        },
        {
          text: "Frist",
          value: "deadLine",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "deadLine",
          dateType: "DD-MM-YYYY",
        },
        {
          text: "Ansvarlig",
          value: "contactPersonName",
          type: "string",
          show: true,
          filterValues: [this.profile.id],
          filterClause: 0,
          filterName: "contactPersonOid",
        },
        {
          filterName: "houseOid",
          filterValues: this.houseId ? [this.houseId] : "",
          show: true,
          type: "string",
        },
      ];
      var data = {
        headers: headers,
        itemsPerPage: 3,
        page: 1,
        search: "",
        sortBy: ["deadLine"],
        sortDesc: [false],
      };

      await complaintApi
        .getComplaints(data)
        .then((response) => {
          this.data = response.items;
          this.total = response.totalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goTo(item) {
      const routeName = this.isEnquiry ? "Request" : "Complaint";
      this.$router.push({ name: routeName, params: { id: item.id } });
    },
    getColor(item) {
      if (item?.color) {
        return item.color;
      } else if (item) {
        switch (item.lineStatus) {
          case 0:
          case 1:
          case 4:
          case 7:
            this.$set(item, "color", "warning");
            break;
          case 2:
          case 3:
          case 5:
            this.$set(item, "color", "success");
            break;
          case 6:
            this.$set(item, "color", "error");
            break;
        }
      }
    },
    getChips(item: any) {
      var data = [
        {
          title: item.regStatus,
          color: item.color,
        },
      ];
      if (item.isCondominiumComplaint) {
        data.push({
          title: "Sameie",
          color: "",
        });
      }

      return data;
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
  },
  components: {
    CollapsibleCard,
    ShowCollapsibleCardBtns,
    CaseCard,
  },
});
</script>

<style lang="scss">
.cardBtn-active {
  background-color: var(--v-cardBtnBadge-base) !important;
  &:before {
    display: none;
  }
}
</style>
